
<button class = "m-1 btn btn-light btn-outline-dark"
    (click) = "GenerateSummaries()">
        Generate attendance Summaries
</button>
